import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { SessionService } from '../../session/session.service';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { filter, map, switchMap } from 'rxjs';
import { ConfirmationDialogComponent } from '../../core/dialogs/confirmation-dialog/confirmation-dialog.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { M3Breakpoints } from '../../shared/breakpoints';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sp-user-button',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
  ],
  templateUrl: './user-button.component.html'
})
export class UserButtonComponent {

  private readonly sessionService = inject(SessionService);
  private readonly dialog = inject(MatDialog);
  private readonly translate = inject(TranslateService);
  private readonly router = inject(Router);
  private readonly breakpointObserver = inject(BreakpointObserver);

  protected readonly userName = computed(() => this.sessionService.user()?.name);
 
  protected readonly isCompact = toSignal(this.breakpointObserver.observe(M3Breakpoints.Compact).pipe(map(result => result.matches)));

  protected logout(): void {
    this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: this.translate.instant('userButton.logoutConfirmationTitle'),
        message: this.translate.instant('userButton.logoutConfirmationMessage'),
      }
    })
      .afterClosed()
      .pipe(
        filter(result => result === true),
        switchMap(() => this.sessionService.logout())
      )
      .subscribe(() => this.router.navigate(['/login']));
  }
}
